"use client";

import Logo from "../../components/svg/logo"
import IconEmailViolet from "../../components/svg/emailViolet"
import IconPhoneViolet from "../../components/svg/phoneViolet"
import IconFacebookViolet from "../../components/svg/facebookViolet"
import IconInstagramViolet from "../../components/svg/instagramViolet"
import IconYoutubeViolet from "../../components/svg/youtubeViolet"
import Button from "../../components/button"
import Social from "../../components/social"
import Link from "next/link"
import { usePathname } from "next/navigation";
import Whatsap from "@/app/components/svg/whatsap";
import IconPhone from "@/app/components/svg/phone";

interface FooterProps {
    global: {
        siteEmail: string;
        sitePhone: string;
        instagram: string;
        facebook: string;
        youtube: string;
    }; 
    content: {
        copyRightText: string;
        workTimeTitle: string;
        workingDays: string;
        weekendDays: string;
        socialMediaTitle: string;
    }
    menu: {
        footerMenuTitle: string;
        footerMenuItem: Array<{
            name: string;
            url: string;
        }>;
    }
    secondMenu: {
        footerMenuTitle: string;
        footerMenuItem: Array<{
            name: string;
            url: string;
        }>;
    }
}

const FooterContent: React.FC<FooterProps> = ({ global, content, menu, secondMenu }) =>  {

    const pathname = usePathname();
    const isEn = pathname.startsWith("/en");

    return (
        <footer className="bg-yellow-50 py-14">
            <div className="container flex max-[767px]:flex-wrap">
                <div className="max-[767px]:w-full">
                    <Logo />
                    <p className="text-base leading-[125%] tracking-[0.02em] text-violet-300 pt-2">{content.copyRightText}</p>
                </div>
                <div className="ml-auto flex gap-6 items-start max-[767px]:w-full max-[767px]:pt-[24px] max-[576px]:gap-[8px]">
                    <a href={`tel:${global.sitePhone}`}>
                        <Button text={global.sitePhone} notuppercase="yes"  icon={<IconPhoneViolet />} type="third" />
                    </a>
                    <a href={`mailto:${global.siteEmail}`}>
                        <Button text={global.siteEmail} notuppercase="yes" icon={<IconEmailViolet />}  type="third" />
                    </a>
                </div>
            </div>
            <div className="container flex mt-4 pt-4 border-t-2 border-dotted border-gray-200 gap-12 
                max-[992px]:flex-wrap
                max-[992px]:justify-between
                max-[767px]:mt-[24px]
            ">
                <div className="w-[294px] max-[992px]:w-[(calc(50% - 15px))]">
                    <h5 className="text-violet-300 font-regular text-[20px] leading-[120%] tracking-[0.05em] uppercase max-[576px]:text-[14px]">
                        {menu.footerMenuTitle}
                    </h5>
                    <div className="mt-2 flex flex-col items-start">
                        {menu.footerMenuItem.map((item: { url: string; name: string }, index: number) => {
                            return (
                                <Link key={index} href={isEn ? `/en${item.url}` : item.url}
                                className="pt-4 text-gray-900 text-base leading-[125%] tracking-[0.02em] font-medium max-[576px]:text-[14px]">
                                    {item.name}
                                </Link>
                            );
                        })}
                    </div>
                </div>
                <div className="w-[294px] max-[992px]:w-[(calc(50% - 15px))]">
                    <h5 className="text-violet-300 font-regular text-[20px] leading-[120%] tracking-[0.05em] uppercase max-[576px]:text-[14px]">
                        {secondMenu.footerMenuTitle}
                    </h5>
                    <div className="flex flex-col items-start">
                        {secondMenu.footerMenuItem.map((item: { url: string; name: string }, index: number) => {
                            return (
                                <Link key={index} href={isEn ? `/en${item.url}` : item.url}
                                className="pt-4 text-gray-900 text-base leading-[125%] tracking-[0.02em] font-medium max-[576px]:text-[14px]">
                                    {item.name}
                                </Link>
                            );
                        })}
                    </div>
                </div>
                <div className="w-[294px] max-[992px]:w-[(calc(50% - 15px))]">
                    <h5 className="text-violet-300 font-regular text-[20px] leading-[120%] tracking-[0.05em] uppercase max-[576px]:text-[14px]">
                        {content.workTimeTitle}
                    </h5>
                    <p className="mt-2 text-gray-900 text-base leading-[125%] tracking-[0.02em] font-medium max-[576px]:text-[14px]">
                        {content.workingDays}
                    </p>
                    <p className="mt-2 text-gray-900 text-base leading-[125%] tracking-[0.02em] font-medium max-[576px]:text-[14px]">
                        {content.weekendDays}
                    </p>
                </div>
                <div className="w-[294px] max-[992px]:w-[(calc(50% - 15px))] ">
                    <h5 className="text-violet-300 font-regular text-[20px] leading-[120%] tracking-[0.05em] uppercase max-[576px]:text-[14px] text-right max-[992px]:text-start">{content.socialMediaTitle}</h5>
                    <div className="flex justify-end gap-4 mt-4 max-[992px]:justify-start">
                        <Social href={global.facebook} icon={<IconFacebookViolet />} />
                        <Social href={global.instagram} icon={<IconInstagramViolet />} />
                        <Social href={global.youtube} icon={<IconYoutubeViolet />} />
                    </div>
                </div>
            </div>
            <Link
                href="tel:086695559"
                rel="noopener noreferrer"
                className="fixed bottom-6 right-6 z-50 bg-yellow-500  hover:bg-yellow-300 text-white rounded-full p-2 shadow-lg transition-colors duration-300 shake"
                aria-label="Chat on WhatsApp"
                >
                <IconPhone />
                
            </Link>


        </footer>
    )
}

export default FooterContent